import { CONFIG } from "src/config";

/**
 * Permanent warning strip shown only when a locally-running client is wired to
 * the production project (`yarn dev:prod`).
 *
 * The whole risk of that mode is forgetting you are in it — deleting an order or
 * editing a profile believing it is test data. So this is deliberately loud,
 * fixed to the top, and impossible to dismiss. It renders nothing in every other
 * configuration, including real production builds.
 */
export function ProdBackendBanner() {
	if (!CONFIG.IS_LOCAL_ON_PROD) return null;

	return (
		// sticky, not fixed: a sticky element still takes up its own row, so it
		// pushes the header down instead of covering it — while staying visible
		// when the page scrolls, which is the whole point of the warning.
		<div
			dir="rtl"
			className="sticky top-0 z-[9999] bg-danger text-white text-center text-sm font-bold py-1 px-3 shadow-md pointer-events-none"
		>
			⚠ מחובר לשרת הפרודקשן (cana-prod) — הנתונים אמיתיים
		</div>
	);
}
